import type { LandingData } from "../data/types"
import { CoverageLine } from "../components/CoverageLine"
import { CTA } from "../components/CTA"

export function Section1Hero({ data }: { data: LandingData }) {
  return (
    <div className="copy-block hero-copy" data-motion="reveal">
      <p className="eyebrow mono">VERUS</p>
      <h1>MARKET SIGNAL, VERIFIED</h1>
      <p className="lede">
        A local-first global markets intelligence terminal. <span>{data.stats.symbols}</span>
        {" "}instruments, <span>{data.stats.exchanges}</span> exchanges, fallback-aware.
        Built for one operator.
      </p>
      <CTA />
      <CoverageLine data={data} />
    </div>
  )
}
